// You can write more code here

/* START OF COMPILED CODE */

import EntityGem from '../EntityGem';
/* START-USER-IMPORTS */
import { GameDataHandler } from '../../GameDataHandler';
import ChunkBase from '../ChunkBase';
import { app } from '../../core/App';
/* END-USER-IMPORTS */

export default class EntitySmallGem extends EntityGem {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 23.5, y ?? 10);

    // gem
    const gem = scene.add.image(0, 12.5, 'game', 'gem-blue.png');
    this.add(gem);

    // sparkle
    const sparkle = scene.add.image(8, -2, 'game', 'gem-sparkle.png');
    this.add(sparkle);

    this.gem = gem;
    this.sparkle = sparkle;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private gem: Phaser.GameObjects.Image;
  private sparkle: Phaser.GameObjects.Image;

  /* START-USER-CODE */
  public static gemFrames = ['gem-blue.png', 'gem-green.png', 'gem-pink.png'];

  public reset() {
    this.gem.setFrame(EntitySmallGem.gemFrames[Phaser.Math.Between(0, EntitySmallGem.gemFrames.length - 1)]);

    super.reset();
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.gem.displayWidth, this.gem.displayHeight);

    super.injectMatter(target);

    let x = this.x;
    let y = this.y;
  }

  protected score(): void {
    this.scene.registry.inc(GameDataHandler.keys.Score, 1);
    app.audioHandler.playSound(this.scene, 'SndGemCollect', 'sfx');
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
